import { FC } from 'react';

import { ReferencedRecognition } from '../../lib';
import { ReferenceEntity } from '../../lib/entities/reference';
import { RecognitionPreview } from './recognition-preview';

interface ReferencePreviewProps {
	linkToReference?: boolean;
	onRemove?: VoidFunction;
	reference?: ReferenceEntity | null;
}

export const ReferencePreview: FC<ReferencePreviewProps> = ({ linkToReference, onRemove, reference }) => {
	if (reference instanceof ReferencedRecognition) {
		return <RecognitionPreview linkToReference={linkToReference} onRemove={onRemove} reference={reference} />;
	}

	return null;
};
